export const tenantTokenKey = 'sihterica_tenant_access';
export const superadminTokenKey = 'sihterica_superadmin_access';

export function readToken(key: string): string | null {
  return sessionStorage.getItem(key);
}

export function saveToken(key: string, token: string): void {
  sessionStorage.setItem(key, token);
}

export function clearToken(key: string): void {
  sessionStorage.removeItem(key);
}
